import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { InvoiceDetailService } from "../invoice-detail/invoice-detail.service";
import { CommonService } from "src/app/shared/services/common.service";



@Component({
    selector: "app-qrcode",
    templateUrl: "./qrcode.component.html",
    styleUrls: ["./qrcode.component.scss"],
    encapsulation: ViewEncapsulation.ShadowDom,
})
export class QrcodeComponent implements OnDestroy, OnInit {
    @Input() qrCodeBase64: string | null = null;
    @Input() metaData: any = null;
    @Input() status: string | null = null;
    @Input() isReadyOnly = false;

    @Output() closeQrCodeEvent = new EventEmitter<void>();
    @Output() markAsPaidEvent = new EventEmitter<void>();

    selectedInvoice: any | null = null;
    selectedVehicle: any | null = null;

    private destroy$: Subject<void> = new Subject<void>();

    constructor(
        private invoiceDetailsService: InvoiceDetailService,
        private commonService: CommonService,
    ) { }
    ngOnDestroy(): void {

        this.destroy$.next();
        this.destroy$.complete()
    }

    ngOnInit() {
        this.invoiceDetailsService.invoiceDetailsAsObservables$.pipe(
            takeUntil(this.destroy$),

        ).subscribe((invoiceDetails) => {
            this.selectedInvoice = invoiceDetails;
        });

        this.invoiceDetailsService.selectedVehicleAsObservables$.pipe(
            takeUntil(this.destroy$),
        ).subscribe((vehicle) => {
            this.selectedVehicle = vehicle;
        });
    }

    closeQrCodeHandler() {
        this.closeQrCodeEvent.emit();
    }
    markAsPaidHandler() {
        this.markAsPaidEvent.emit();
    }
    clipboardCopy(text: string) {
        this.commonService.copyToClipboard(text);
    }
}